import React from 'react';
import './index.less'
import {Link} from "umi";

const SmartHardwareOverlay = () => {
  // 智能硬件列表数据
  const imgBasePath = "https://wtb-community.oss-cn-qingdao.aliyuncs.com/zhsqOfficialWebSite/smartHardware/";

  const smartHardwareItems = [
    {
      id: 1,
      href: "smartHardware/bluedoor",
      imgSrc: "bluedoor.png",
      title: "蓝牙门禁",
      desc: "抛弃传统开门方式解决传统开门工具带来的烦恼"
    },
    {
      id: 2,
      href: "smartHardware/facedoor",
      imgSrc: "facedoor.png",
      title: "人脸识别门禁",
      desc: "智能门禁升级版，让业主直接“刷脸回家”"
    },
    {
      id: 3,
      href: "smartHardware/facecamera",
      imgSrc: "facecamera.png",
      title: "人脸识别摄像机",
      desc: "助力物业打造智能化安全防范系统"
    },
    {
      id: 4,
      href: "smartHardware/parcellocker",
      imgSrc: "parcellocker.png",
      title: "智能快递柜",
      desc: "让小区加快实现商业变现，深层次维护小区环境安全"
    },
    {
      id: 5,
      href: "smartHardware/chargingpile",
      imgSrc: "chargingpile.png",
      title: "智能充电桩",
      desc: "专属于小区的智能充电桩，减低电瓶车火灾隐患"
    },
    {
      id: 6,
      href: "smartHardware/parking",
      imgSrc: "parking.png",
      title: "智慧停车",
      desc: "轻松实现驾车无感进出小区，让业主的生活更高效"
    }
  ];
  return (
    <div className="smartHardware">
      <div className="smartHardware_box">
        {smartHardwareItems.map((item) => (
          <Link
            key={`hardware-${item.id}`}
            to={item.href}
            className="list_item"
          >
            <img
              src={`${imgBasePath}${item.imgSrc}`}
              className="yingjian_img"
              alt={item.title}
            />
            <div className="flex_box">
              <div className="text_4">{item.title}</div>
              <div className="text_5">{item.desc}</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SmartHardwareOverlay;
